export default "__VITE_ASSET__BvIQqEtl__"